module.exports = __webpack_public_path__ + "img/5.847f98f1.jpg";